<span class="badge">
  <ng-content></ng-content>
</span>
